// A `user` participant is keyed by its own user id, so the same person imported from
// two templates lands on one trip member rather than two.
export const participantKeyFor = (p, newId) => p.kind === "user" ? p.userId : newId();
// Trip → template ("save this trip as a template"): the trip's members become the
// template's participants, keyed by the *same* ids, so the assignments copied alongside
// them keep pointing at the right people. Roles and per-member settings are dropped —
// they are facts about that trip, not about the template.
export const participantsFromMembers = (members) => {
    const out = {};
    for (const [id, m] of Object.entries(members)) {
        out[id] =
            m.kind === "user"
                ? {
                    kind: "user",
                    userId: id,
                    displayName: m.profile.displayName,
                    email: m.profile.email,
                    ...(m.profile.photoUrl !== undefined ? { photoUrl: m.profile.photoUrl } : {}),
                }
                : {
                    kind: "managed",
                    displayName: m.profile.displayName,
                    ...(m.profile.photoUrl !== undefined ? { photoUrl: m.profile.photoUrl } : {}),
                };
    }
    return out;
};
// The other direction: the member entry an import creates for a participant the trip
// does not have yet. `user` participants land as editors — a traveler has to be able to
// check their own rows off — and managed ones are guarded by whoever ran the import.
export const memberFromParticipant = (p, actor) => p.kind === "user"
    ? {
        kind: "user",
        role: "editor",
        profile: {
            displayName: p.displayName,
            email: p.email,
            ...(p.photoUrl !== undefined ? { photoUrl: p.photoUrl } : {}),
        },
        settings: { stagingOptIn: false },
    }
    : {
        kind: "managed",
        guardianUserIds: [actor],
        profile: {
            displayName: p.displayName,
            ...(p.photoUrl !== undefined ? { photoUrl: p.photoUrl } : {}),
        },
        settings: { stagingOptIn: false },
    };
// Issue #188 — the template's travelers in the shape the completion/staging use-cases
// read (`ParticipantContext`), so a template list renders through the same components
// as a trip's. Two deliberate differences from a trip:
//   - `allowProxyCompletion` is always on. A template has no "me": the editor stages a
//     row on behalf of whichever traveler the row is for, so every chip is clickable.
//   - the entries carry no roles or per-member settings — those are facts about a trip.
//     `memberFromParticipant` supplies the same defaults the import would.
export const participantContextOf = (participants, actor) => {
    const members = {};
    for (const [id, p] of Object.entries(participants ?? {})) {
        members[id] = memberFromParticipant(p, actor);
    }
    return { members, settings: { allowProxyCompletion: true } };
};
//# sourceMappingURL=template.js.map